// Single source of truth for API + client version headers.
// SAYERMORE_API_VERSION is the date this client was built against — used by
// the server to branch behavior for backwards-incompatible breaking changes.
// CLIENT_VERSION is the build number — used for the force-update gate and
// telemetry.
//
// `process.env.*` references are replaced at build time by esbuild's
// `define` (see webapp/build.mjs).

export const API_VERSION = process.env.SAYERMORE_API_VERSION || '2026-05-24';
export const CLIENT_VERSION = process.env.CLIENT_VERSION || '0.1.0-dev';
